import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap } from 'rxjs';
import { quizzesActions } from '../actions/quizzes.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class QuizzesEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getQuizzes$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizzesActions.getQuizzes),
            mergeMap(({ value }) => {
                return this.httpService.getQuizzes(value).pipe(
                    finalizeLoader('quizzes-list'),
                    map(({ payload, total }) => quizzesActions.getQuizzesSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(quizzesActions.getQuizzesError({ code: response.status }))),
                );
            }),
        );
    });
}
